<template>
  <div class="table-menu">
    <a class="divcss5-right" @click="switchVersionClick()" :disabled="(tableStatus.isEdit||tableStatus.selectedVersion.ifEdition||!tableStatus.canModify)" v-if="tableStatus.allowSwitch">
      <span  v-if="tableStatus.fundInfoFlag > 1" >&lt;返回旧版</span>
      <span  v-else>体验新版&gt;</span>
    </a>
    <p class="table-title">
      <span v-if="tableStatus.fundName">{{ tableStatus.fundName }}-公允价值表</span>
    </p>
    <div class="select-group">
      <div class="select-item">
        <label>选择表单：</label>
        <a-select
          size="default"
          style="width: 220px"
          :disabled="tableStatus.menuType !== 'fairTable' && tableStatus.menuType !== 'fund'"
          placeholder="请选择表单"
          :value="tableStatus.selectedTable.name"
        >
          <a-select-option v-for="(item, index) in tableStatus.tableList" :key="index" :value="item.name" @click="selectTable(item)">
            <span style="color: #3f51b5">{{ item.name }}</span>
          </a-select-option>
        </a-select>
        <span
          style="margin-left: 20px; color: #3f51b5"
          v-if="tableStatus.menuType === 'fairTable' && tableStatus.selectedTable.startDate && !!tableStatus.remark === false"
          >({{ tableStatus.selectedTable.startDate }}~{{ tableStatus.selectedTable.endDate }})</span
        >
        <span style="margin-left: 20px; color: #3f51b5" v-else-if="tableStatus.menuType === 'fairTable' && !!tableStatus.remark"
          >({{ tableStatus.remark }})</span
        >
      </div>
      <div class="select-item">
        <a-tooltip placement="top">
          <template slot="title">
            <span v-if="tableStatus.selectedVersion.name">{{ tableStatus.selectedVersion.name }}</span>
          </template>
          <label style="cursor: pointer">
            <span style="margin-right: 4px">版本</span>
            <a-icon style="margin-top: 4px; color: rgb(255, 183, 216)" type="info-circle" />：
          </label>
        </a-tooltip>

        <a-select
          size="default"
          placeholder="请选择版本"
          style="width: 90px"
          :disabled="tableStatus.menuType !== 'fairTable' && tableStatus.menuType !== 'fund'"
          :value="tableStatus.selectedVersion.version"
        >
          <a-select-option v-for="(item, index) in tableStatus.versionList" :key="index" :value="item.version" @click="selectVersion(item)">
            <span style="color: #3f51b5">{{ item.version }}</span>
          </a-select-option>
        </a-select>
        <span style="margin-left: 20px; color: #3f51b5" v-if="tableStatus.selectedVersion.updateDate && tableStatus.selectedVersion.ifEdition">
          ({{ tableStatus.selectedVersion.updateDate }}
          <span v-if="tableStatus.selectedVersion.version === '0'">创建</span>
          <span v-else>保存</span>)
        </span>
        <div v-if="tableStatus.selectedVersion.userName" class="author" style>{{ tableStatus.selectedVersion.userName }}</div>
      </div>
    </div>
    <div class="menu-group">
      <div v-for="item in menuBtnsVisible" :key="item.id">
        <div class="menu-btn" :data-ga-id="'北冥-公允价值表-报表操作-'+item.name"
          :class="{ seperator: item.seperator && item.status !== -1 }" 
          v-if="item.id !== 12" 
          @click="handleMenu(item)"
          >
          <img :src="item.status === 1 ? item.iconActive : item.iconInActive" />
          <div class="hint" :class="{ 'hint-inactive': item.status === 0 }">({{ item.name }})</div>
          <div class="divider divider-inactive" v-if="item.id !== 6 && item.id !== 14"></div>
        </div>
        <div class="menu-btn">
          <a-popconfirm
            v-if="item.id === 12 && item.status === 1"
            title="确定删除报表（含所有版本）?"
            @confirm="handleMenu(item)"
            okText="确定"
            cancelText="取消"
            data-ga-id="'北冥-公允价值表-报表操作-删除报表"
          >
            <img :src="item.iconActive" />
            <div class="delete-hint" style="color: red">删除报表</div>
          </a-popconfirm>
          <img v-if="item.id === 12 && item.status === 0" :src="item.iconInActive" />
          <div v-if="item.id === 12 && item.status === 0" class="delete-hint" style="color: #cdcdcd">删除报表</div>
        </div>
      </div>
    </div>
    <a-modal v-model="dialogStatus.visible" :title="dialogStatus.title" :footer="null" :width="[5, 7, 11].includes(dialogStatus.id) ? 800 : [8,10].includes(dialogStatus.id) ? 1050 : 416">
      <functionalDialog
        v-if="dialogStatus.visible"
        :dialogId="dialogStatus.id"
        :versionId="tableStatus.selectedVersion.id"
        :tableInfo="tableStatus"
        @cancel="cancel"
        @confirm="confirm"
      ></functionalDialog>
    </a-modal>
  </div>
</template>
<script>
import functionalDialog from './dialog.vue';
import Event from '@/utils/event';
import moment from 'moment';
import { fixVersion, nameLogVersion, newVersion, publish, deleteFair, newForecast, renameFair,switchVersion, queryVersionType } from '@/api/finance';
export default {
  data() {
    return {
      tableStatus: {
        globalActive: false,
        canModify: false,
        fundId: false,
        fundName: null,
        tableId: false,
        isEdit: false,
        isCompare: false,
        ifRelease: false,
        ifEdition: false,
        remark: false, //是否为预测表
        version: false,
        versionList: [],
        selectedTable: {
          id: null,
          name: '',
          startDate: '',
          endDate: '',
          versionList: [] //已经单拎，无用
        },
        tableList: [],
        selectedVersion: {
          id: null,
          name: '',
          version: ''
        },
        fundInfoFlag: undefined,
        menuType: undefined
      },
      menuBtns: [
        {
          id: 13,
          status: 1,
          iconActive: `/financeImg/rename.png`,
          iconInActive: `/financeImg/rename-gray.png`,
          name: `表单更名`
        },
        {
          id: 0,
          status: 1, // 1: active, 0: inactive, -1: 不显示
          iconActive: `/financeImg/edit.png`,
          iconInActive: `/financeImg/edit-gray.png`,
          name: `编辑`
        },
        {
          id: 1,
          status: 1, // 1: active, 0: inactive, -1: 不显示
          iconActive: `/financeImg/save.png`,
          iconInActive: `/financeImg/save-gray.png`,
          name: `保存`
        },
        {
          id: 2,
          status: 1,
          iconActive: `/financeImg/fixed.png`,
          iconInActive: `/financeImg/fixed-gray.png`,
          name: `定版本`
        },
        {
          id: 3,
          status: 1,
          iconActive: `/financeImg/setName.png`,
          iconInActive: `/financeImg/setName-gray.png`,
          name: `命名`
        },
        {
          id: 4,
          status: 1,
          iconActive: `/financeImg/log.png`,
          iconInActive: `/financeImg/log-gray.png`,
          name: `版本log`
        },
        {
          id: 5,
          status: 1,
          iconActive: `/financeImg/export.png`,
          iconInActive: `/financeImg/export-gray.png`,
          name: `导出`
        },
        {
          id: 6,
          status: 1,
          iconActive: `/financeImg/compare.png`,
          iconInActive: `/financeImg/compare-gray.png`,
          name: `版本对比`
        },
        {
          id: 7,
          status: -1,
          iconActive: `/financeImg/new.png`,
          iconInActive: `/financeImg/new-gray.png`,
          name: `新建`,
          seperator: true
        },
        {
          id: 8,
          status: 1,
          iconActive: `/financeImg/refresh.png`,
          iconInActive: `/financeImg/refresh-gray.png`,
          name: `刷新数据`,
          seperator: true
        },
        {
          id: 9,
          status: 1,
          iconActive: `/financeImg/forcast.png`,
          iconInActive: `/financeImg/forcast-gray.png`,
          name: `预测表`
        },
        {
          id: 10,
          status: 1,
          iconActive: `/financeImg/publish.png`,
          iconInActive: `/financeImg/publish-gray.png`,
          name: `发布`
        },
        // {
        //   id: 11,
        //   status: 1,
        //   iconActive: `/financeImg/check.png`,
        //   iconInActive: `/financeImg/check-gray.png`,
        //   name: `系统校验`
        // },
        {
          id: 12,
          status: 1,
          iconActive: `/financeImg/delete.png`,
          iconInActive: `/financeImg/delete-gray.png`,
          name: `删除报表（含所有版本）`
        },
        {
          id: 14,
          status: 1,
          iconActive: `/financeImg/export.png`,
          iconInActive: `/financeImg/export-gray.png`,
          name: `导出ir大表`
        }
      ],
      dialogStatus: {
        title: null,
        visible: false,
        id: null
      },
      versionId: undefined
    };
  },
  computed: {
    menuBtnsVisible() {
      let condition;
      let absence = [];
      let disabled = [];
      let enabled = [];
      let canCompare = true;
      let all = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13,14];
      if (!this.tableStatus.globalActive) {
        condition = -1;
      } else if (!this.tableStatus.canModify) {
        condition = -0.5;
      } else if (this.tableStatus.selectedTable.ifRelease) {
        condition = 5;
      } else if (this.tableStatus.isEdit) {
        condition = 0;
      } else if (this.tableStatus.isCompare) {
        condition = 0.1;
      } else if (this.tableStatus.menuType !== 'fairTable') {
        condition = 1;
      } else if (this.tableStatus.selectedVersion.version === '0') {
        condition = 2;
      } else if (this.tableStatus.selectedVersion.version !== '0' && !this.tableStatus.selectedVersion.ifEdition) {
        condition = 3;
      } else if (this.tableStatus.selectedVersion.ifEdition && !this.tableStatus.selectedTable.ifRelease) {
        condition = 4;
      }

      /**
       * 按钮可用情况
       *
       * 编辑状态，只有一种情况，存在于2、3、4；删除不可用
       * -1、（完全不可用），侧边栏没有点到leaf上去，
       * -0.5、（没有编辑权限），保存[1]，新建[7]不存在，导出[5]是否可用要看是否有表，其他不可用
       * 0、（编辑状态）编辑[0]，新建[7]不存在，保存[1]，命名[3]，版本log[4],表单更名[13]可用，其他不可用
       * 0.1、（版本对比状态）编辑[0]，新建[7]不存在，刷新[8]存在，保存[1]，命名[3]，版本log[4]可用，其他不可用
       * 1、（没有表, menuType !== fairTable）没有点击到表上，新建[7]存在可用，保存[1]、刷新[8]不存在，除了[7]新建[11]系统校验可用，其他不可用
       *
       * 2、（0.0版本的表, this.version === '0'），新建[7]不存在，刷新[8]存在可用，定版本[2]不可用，发布[10]是否可用要看是否有未定版本，其他可用
       * 3、（高于0.0的未定版表, !ifEdition && version !== '0'），新建[7]不存在，刷新[8]存在可用，发布[10]不可用，其他可用
       * 4、（高于0.0的定版本, ifEdition === true && ifRelease === false），新建[7]不存在，刷新[8]存在，定版本[2]不可用，发布[10]是否可用要看是否有未定版本，其他可用
       *
       * 5、（发布，final版, ifRelease === true），新建[7]不存在，刷新[8]存在，导出[5]、版本对比[6]、预测表[9]、系统校验[11]]、表单更名[13]可用，其他不可用
       *
       * 20210427 增加表单更名[13],可用情况与可编辑相同
       */

      switch (condition) {
      case -1:
        absence = [1, 8];
        disabled = [0, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13,14];
        break;
      case -0.5:
        absence = [1, 7];
        disabled = [0, 2, 3, 4, 6, 8, 9, 10, 11, 12, 13];
        if (this.tableStatus.menuType !== 'fairTable') {
          disabled.push(5);
          disabled.push(14);
        }
        break;
      case 0:
        absence = [0, 7];
        disabled = [2, 5, 6, 8, 9, 10, 11, 12,14];
        break;
      case 0.1:
        absence = [1, 7];
        disabled = [0, 2, 3, 4, 5, 8, 9, 10, 11, 12,14];
        break;
      case 1:
        absence = [1, 8];
        disabled = [0, 2, 3, 4, 5, 6, 9, 10, 12, 13,14];
        break;
      case 2: //选中0.0版本
      case 4: //选中一个定了的版本
        absence = [1, 7];
        disabled = [2];
        if (
        //能否发布看该版本是否为最后版本
          this.tableStatus.selectedVersion.id !== this.tableStatus.versionList[0].id
        ) {
          disabled.push(10);
        }
        if (this.tableStatus.remark) {
          disabled.push(9);
        }
        break;
      case 3: //选中一个未定版本
        absence = [1, 7];
        disabled = [10];
        if (this.tableStatus.remark) {
          disabled.push(9);
        }
        break;
      case 5: //已经发布
        absence = [1, 7];
        enabled = [5, 6, 9, 11, 13,14];
        disabled = all.filter(item => {
          return !enabled.includes(item);
        });
        break;
      }
      // TODO menuBtns
      this.menuBtns = this.menuBtns.map((item, index) => {
        if (absence.includes(item.id)) {
          item.status = -1;
        } else if (disabled.includes(item.id)) {
          item.status = 0;
        } else {
          item.status = 1;
        }
        return item;
      });
      // 如果fundInfoFlag大于1，则把id为6(版本对比)的btn设置为disable
      if (!canCompare) {
        this.menuBtns.forEach(item => {
          if (item.id === 6) {
            item.status = 0;
          }
        });
      }
      this.menuBtns.forEach(item => {
        if (item.id === 14) {
          if (!this.tableStatus.allowSwitch) {
            item.status = -1;
          } else if(this.tableStatus.fundInfoFlag<=1){
            item.status = 0;
          } else if( 'RMB V精选'===this.tableStatus.fundName || 'USD V'===this.tableStatus.fundName || 'RMB IV'===this.tableStatus.fundName){
            item.status = 0;
          }
        }
      });

      return this.menuBtns.filter(item => {
        return item.status !== -1;
      });
    }
  },
  components: { functionalDialog },
  mounted() { },
  mounted() {
    Event.$on('refreshMenu', table => {
      if(table.allowBack !== undefined){
        this.tableStatus.allowBack = table.allowBack;
        return;
      }
      this.tableStatus.globalActive = true;
      if (table.selectedTable && table.selectedTable.versionList.length) {
        this.versionId = table.selectedTable.versionList[0].id;
        queryVersionType({ versionId: this.versionId }).then(res => {
          this.tableStatus.fundInfoFlag = res.data;
        });
      }
      this.render(table);
    });
    Event.$on('refreshMenuForSelectTable', table => {
      this.tableStatus.globalActive = true;
      if (table.selectedTable && table.selectedTable.versionList.length) {
        this.versionId = table.selectedTable.versionList[0].id;
        queryVersionType({ versionId: this.versionId }).then(res => {
          this.tableStatus.fundInfoFlag = res.data;
        });
      }
      this.render(table);
    });
    Event.$on('deactivateMenu', () => {
      this.tableStatus.globalActive = false;
      this.tableStatus.fundInfoFlag = null;
    });
  },
  methods: {
    render(table) {
      this.tableStatus.remark = table.remark;
      this.tableStatus.isCompare = false;
      this.tableStatus.isEdit = false;
      this.tableStatus.menuType = table.menuType;
      //有选中的table
      if (table.menuType === 'fairTable') {
        const selectedTable = table.selectedTable;
        Object.assign(this.tableStatus, {
          selectedTable: selectedTable,
          ifRelease: selectedTable.ifRelease,
          tableId: selectedTable.id,
          fundId: table.fundId,
          fundName: table.fundName,
          selectedVersion: selectedTable.versionList[0],
          ifEdition: selectedTable.versionList[0].ifEdition,
          versionList: selectedTable.versionList,
          tableList: table.tableList,
          canModify: table.canModify,
          allowSwitch: table.allowSwitch,
          fundInfoFlag: table.fundInfoFlag
        });
      } else if (table.menuType === 'fund') {
        Object.assign(this.tableStatus, {
          selectedTable: {},
          ifRelease: false,
          ifEdition: false,
          fundId: table.fundId,
          fundName: table.fundName,
          tableId: null,
          versionList: [],
          tableList: table.tableList,
          selectedVersion: {
            id: null,
            name: '',
            version: ''
          },
          canModify: table.canModify
        });
      } else {
        Object.assign(this.tableStatus, {
          selectedTable: {},
          ifRelease: false,
          ifEdition: false,
          fundId: table.fundId,
          fundName: table.fundName,
          tableId: null,
          versionList: [],
          tableList: [],
          selectedVersion: {
            id: null,
            name: '',
            version: ''
          },
          canModify: table.canModify
        });
      }
    },
    async newVersion() {
      await newVersion({
        versionId: this.tableStatus.selectedVersion.id
      }).then(res => {
        let newVersionId = res.data.versionId;
        this.tableStatus.versionList.unshift({
          id: newVersionId,
          name: '',
          version: parseInt(this.tableStatus.versionList[0].version, 10) + 1,
          updateDate: moment().format('YYYY.MM.DD'),
          userName: this.$store.state.user.userInfo.nickname,
          fairId: this.tableStatus.selectedTable.id,
          ifEdition: false
        });
        this.tableStatus.selectedVersion = this.tableStatus.versionList[0];
      });
    },
    switchVersionClick(){
      switchVersion({
        versionId: this.tableStatus.selectedVersion.id
      }).then(res => {
        if (res.code === 200) {
          debugger;
          this.tableStatus.fundInfoFlag = res.data;
          Event.$emit('refreshTable', {
            versionId: this.tableStatus.selectedVersion.id
          });
          Event.$emit('refreshMenu', {
            menuType: this.tableStatus.menuType,
            fundId: this.tableStatus.fundId,
            fundName: this.tableStatus.fundName,
            canModify: this.tableStatus.canModify,
            allowSwitch: this.tableStatus.allowSwitch,
            fundInfoFlag: this.tableStatus.fundInfoFlag
          });
        }
      });

    },
    async handleMenu(menu) {
      // 编辑要首先判断该版本之后是否有未定版版本
      if (menu.status === 1) {
        const dialogTitles = [
          '编辑-历史版本',
          '',
          '版本-定版',
          '版本-重命名',
          '保存-版本log',
          '导出数据',
          '版本对比',
          '新建',
          '刷新数据',
          '新建预测表',
          '',
          '系统校验',
          '',
          '表单更名'
        ];
        switch (menu.id) {
        case 0:
          if (
          // 最新版已经定版本情况
          // this.tableStatus.selectedVersion.version === 0 &&
          // this.tableStatus.versionList.length === 1
            this.tableStatus.versionList[0].ifEdition
          ) {
            await this.newVersion();
            this.tableStatus.isEdit = true;
            Event.$emit('menu-edit-save', {
              type: 'new-version',
              versionId: this.tableStatus.selectedVersion.id
            });
          } else if (
          //最新版本未定且当前版本不是最新版本
            this.tableStatus.versionList[0].ifEdition !== true &&
              this.tableStatus.selectedVersion.id !== this.tableStatus.versionList[0].id
          ) {
            this.dialogStatus.title = '编辑-历史版本';
            this.dialogStatus.visible = true;
            this.dialogStatus.id = menu.id;
          } else {
            this.tableStatus.isEdit = true;
            Event.$emit('menu-edit-save', { type: 'edit' });
          }
          break;
        case 1:
          this.tableStatus.isEdit = false;
          Event.$emit('menu-edit-save', { type: 'save' });
          break;
        case 6:
          if (this.tableStatus.isCompare) {
            this.tableStatus.isCompare = false;
            this.menuBtns.forEach(e => {
              if (e.id === 6) {
                e.name = '版本对比';
              }
            });
            Event.$emit('menu-compare', { compare: false });
          } else {
            this.dialogStatus.title = dialogTitles[menu.id];
            this.dialogStatus.id = menu.id;
            this.dialogStatus.visible = true;
          }
          break;
        case 8:
          if (this.tableStatus.versionList[0].ifEdition) {
            await this.newVersion();
            this.tableStatus.isEdit = true;
            Event.$emit('menu-edit-save', {
              type: 'new-version',
              versionId: this.tableStatus.selectedVersion.id
            });
          }
          this.dialogStatus.title = dialogTitles[menu.id];
          this.dialogStatus.id = menu.id;
          this.dialogStatus.visible = true;
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 7:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
          this.dialogStatus.title = dialogTitles[menu.id];
          this.dialogStatus.id = menu.id;
          this.dialogStatus.visible = true;
          break;
        case 12:
          //删除一张表
          deleteFair({
            fairId: this.tableStatus.selectedTable.id
          }).then(res => {
            if (res.code === 200) {
              // this.$store.commit("finance/setMenuId", -1);
              this.tableStatus.tableList = [];
              this.tableStatus.version = false;
              Object.assign(this.tableStatus, {
                remark: false,
                version: false,
                versionList: [],
                selectedTable: {
                  id: null,
                  name: '',
                  startDate: '',
                  endDate: ''
                },
                tableList: [],
                selectedVersion: {
                  id: null,
                  name: '',
                  version: ''
                }
              });
              Event.$emit('refresh-fund');
              Event.$emit('deactivateTable');
              Event.$emit('deactivateMenu');
            }
          });
          break;
        default:
          break;
        }
      }
    },
    selectTable(selectedTable) {
      this.tableStatus.menuType = 'fairTable';
      Event.$emit('invisibleHint');
      this.tableStatus.selectedTable = selectedTable;
      this.tableStatus.tableId = selectedTable.id;
      this.tableStatus.versionList = selectedTable.versionList;
      this.tableStatus.selectedVersion = selectedTable.versionList[0];
      this.$store.commit('finance/setMenuId', `fairMenu_${selectedTable.id}`);
      Event.$emit('refreshMenuForSelectTable',this.tableStatus);
      Event.$emit('refreshTable', {
        versionId: this.tableStatus.selectedVersion.id
      });
    },
    selectVersion(item) {
      this.tableStatus.selectedVersion = item;
      this.versionId = item.id;
      queryVersionType({ versionId: this.versionId }).then(res => {
        this.tableStatus.fundInfoFlag = res.data;
      });
      Event.$emit('refreshTable', {
        versionId: this.versionId
      });
    },
    cancel() {
      this.dialogStatus.visible = false;
    },
    async confirm(msg) {
      const event = msg.event;
      switch (event) {
      case 'edit-save':
        await this.newVersion();
        Event.$emit('menu-edit-save', {
          type: 'new-version',
          versionId: this.tableStatus.selectedVersion.id
        });
        this.tableStatus.isEdit = true;
        break;
      case 'compare':
        Event.$emit('menu-compare', msg);
        this.menuBtns.forEach(e => {
          if (e.id === 6) {
            e.name = '取消对比';
          }
        });
        this.tableStatus.isCompare = true;
        break;
      case 'fix-version':
        fixVersion({
          versionName: msg.name,
          log: msg.log,
          versionId: this.tableStatus.selectedVersion.id
        }).then(res => {
          if (res.code === 200) {
            Event.$emit(
              'refreshMenuAndTable',
              Object.assign({}, this.tableStatus.selectedTable, {
                canModify: true,
                remark: this.tableStatus.remark,
                menuType: this.tableStatus.menuType
              })
            );
          }
        });
        break;
      case 'name-log-version':
        nameLogVersion({
          versionName: msg.name,
          versionLog: msg.log,
          versionId: this.tableStatus.selectedVersion.id
        }).then(() => {
          this.tableStatus.selectedVersion.name = msg.name;
        });
        break;
      case 'publish':
        publish({
          fairId: this.tableStatus.selectedTable.id
        }).then(res => {
          if (res.code === 200) {
            Event.$emit(
              'refreshMenuAndTable',
              Object.assign({}, this.tableStatus.selectedTable, {
                canModify: true,
                remark: this.tableStatus.remark,
                menuType: this.tableStatus.menuType
              })
            );
            Event.$emit('refresh-fund');
          }
        });
        break;
      case 'new-forecast':
        newForecast({
          versionId: this.tableStatus.selectedVersion.id,
          name: msg.name
        }).then(() => {
          Event.$emit('refresh-fund');
        });
        break;
      case 'new-table':
        Event.$emit('refresh-fund');
        // Event.$emit('switchSideMenu', {
        //   name: msg.name,
        //   id: msg.tableId,
        //   canModify: true,
        //   isLeaf: true
        // });
        // Event.$emit('refreshTable', {
        //   versionId: msg.versionId
        // });
        break;
      case 'refresh-table':
        Event.$emit('refreshTable', {
          versionId: msg.versionId
        });
        break;
      case 'rename':
        renameFair({
          fairName: msg.name,
          versionId: this.tableStatus.selectedVersion.id
        }).then(() => {
          Event.$emit('refresh-fund');
          this.tableStatus.selectedTable.name = msg.name;
        });
        break;
      case 'switch-version':
        switchVersion({
          versionId: this.tableStatus.selectedVersion.id
        }).then(res => {
          if (res.code === 200) {
            this.$emit('confirm', {
              event: 'refresh-table',
              versionId: this.tableInfo.selectedVersion.id
            });
          }
        });
        break;
      default:
        break;
      }
      this.dialogStatus.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.table-menu {
  .table-title {
    font-size: 24px;
    font-weight: bold;
    span {
      &:nth-of-type(1) {
        font-size: 24px;
        font-weight: bold;
      }
      &:nth-of-type(2) {
        font-size: 18px;
        color: red;
      }
    }
  }
  .divcss5-right{
    float:right;
    font-size: 20px;
  }
  .select-group {
    display: flex;
    .select-item {
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 50px 20px 0;
      .author {
        border-radius: 100px;
        width: 40px;
        height: 40px;
        background: rgb(255, 183, 108);
        text-align: center;
        line-height: 40px;
        color: white;
        margin-left: 10px;
      }
    }
  }
  .menu-group {
    position: relative;
    margin-bottom: 50px;
    width: 100%;
    height: 40px;
    background: rgb(250, 240, 224);
    display: flex;
    align-items: center;
    padding: 0 0 0 0px;
    .menu-btn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 80px;
      img {
        width: 20px;
        height: 20px;
      }
      .hint {
        position: absolute;
        top: 40px;
        width: 60px;
        text-align: center;
      }
      .hint-inactive {
        color: #cdcdcd;
      }
      .delete-hint {
        position: absolute;
        top: 40px;
        left: 0;
        width: 100%;
        text-align: center;
      }
    }
    .seperator {
      margin-left: 100px;
      flex: 3;
    }
    .divider {
      position: absolute;
      width: 2px;
      height: 70%;
      background: #1890ff;
      top: 6px;
      right: 0;
    }
    .divider-inactive {
      background: #cdcdcd;
    }
  }
}
</style>
